export default __webpack_public_path__ + "static/media/deardiary.026fd090.mp4";